module.exports = __webpack_public_path__ + "1.4.15-unryo/img/manage.6c246342.jpg";